export default __webpack_public_path__ + "static/media/InstalcoNet.89523b6f.jpeg";